import {utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, useIntl} from 'react-intl';

import stylesAutoLayout from './AutoLayout.less';

const I18N = defineMessages({
  LAST_CHANGE_AUTHOR: {
    id: 'autoLayout.screen.lastChangeAuthor',
    defaultMessage: 'Last change author',
    description: 'title of user of last screen change',
  },
});

const LastChangeAuthor = ({name}) => {
  const intl = useIntl();
  const title = name
    ? utils.TranslateUtils.translate(I18N.LAST_CHANGE_AUTHOR.id, intl)
    : null;

  /* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */
  return (
    <div
      className={classNames(
        'form-group',
        stylesAutoLayout.dlScreenComponent,
        stylesAutoLayout.dlTextOnly
      )}
    >
      <label className={stylesAutoLayout.dlComponentLabel} title={title}>
        {title}
      </label>
      <span className={stylesAutoLayout.dlScreenComponentInput} title={name}>
        {name}
      </span>
    </div>
  );
  /* eslint-enable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */
};

LastChangeAuthor.propTypes = {
  name: PropTypes.string.isRequired,
};

export default LastChangeAuthor;
